import { TFunction } from 'react-i18next';
import { getErrorMessage } from '@/helpers/campaignValidations';

interface Attribute {
  errors: {
    max?: boolean;
    min?: boolean;
    required?: boolean;
  }
  invalid: boolean;
}

export const maxLengthError = (value: string, maxLength: number, t: TFunction) => (value?.length === maxLength && t('validations.maxLength', { maxLength }));

export const getMessage = (attribute: Attribute, maxLength: number | null = null, t: TFunction) => t(getErrorMessage(attribute?.errors), { maxLength });

export const errorMessage = (attribute: Attribute, maxLength: number, t: TFunction) => getMessage(attribute, maxLength, t);

export const labelFormat = (tab: string) => tab.toLowerCase().replace(/_./g, (match) => match.charAt(1).toUpperCase());